<!--
 * @Author:
 * @LastEditTime: 2024-06-17 17:46:03
 * @Description: 承包商开工许可
-->
<template>
  <el-card class="h-full relative" v-if="isList">
    <div class="mb-20px">
      <el-input
        size="mini"
        clearable
        placeholder="请输入单位名称、单位负责人"
        class="!w-50 mr-10px"
        v-model="searchData.search"
      />
      <el-date-picker
        v-model="searchData.applyTimeStart"
        size="small"
        clearable
        type="date"
        placeholder="申报开始日期"
        value-format="yyyy-MM-dd"
        class="!w-50 mr-10px"
      >
      </el-date-picker>
      <el-date-picker
        v-model="searchData.applyTimeEnd"
        size="small"
        clearable
        type="date"
        placeholder="申报结束日期"
        value-format="yyyy-MM-dd"
        class="!w-50 mr-10px"
      >
      </el-date-picker>
      <el-select
        v-model="searchData.workflowStatus"
        size="mini"
        placeholder="流程状态"
        class="!w-50 mr-10px"
        clearable
      >
        <el-option
          v-for="item in WorkflowList"
          :key="item.code"
          :label="item.displayName"
          :value="item.code"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
      <el-button size="small" @click="resetSearch">重置</el-button>
      <el-button
        class="mr-10px"
        size="small"
        type="primary"
        @click="openPermission"
        :disabled="!(contractorId && $hasAccess('create'))"
        >新增</el-button
      >
      <PreviewButton :menuId="menuId"></PreviewButton>
    </div>
    <el-table
      stripe
      ref="eltable"
      :height="tableHeight"
      class="mt-10px"
      border
      :data="tableData"
      @sort-change="sortChangeTable"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" type="index" width="60"> </el-table-column>
      <el-table-column label="单位名称" prop="orgName" sortable></el-table-column>
      <!-- <el-table-column label="所属项目" prop="projectName" sortable></el-table-column> -->
      <el-table-column label="单位负责人" prop="orgLeader" sortable></el-table-column>
      <el-table-column label="联系电话" prop="phoneNumber" sortable></el-table-column>
      <el-table-column label="申报时间" prop="applyTime" sortable>
        <template slot-scope="scope">{{
          dayjs(scope.row.applyTime).format('YYYY-MM-DD')
        }}</template>
      </el-table-column>
      <el-table-column label="流程状态" prop="workflowStatus" sortable>
        <template slot-scope="scope">
          <el-tag size="mini" :type="workFlowStatusTypes(scope.row.workflowStatus)">{{
            filtersWorkflowStatus(scope.row.workflowStatus)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="280" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right mt-20px"
      background
      @size-change="handleSearch()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <operate-api-dialog
      v-if="showOperateApiDialog"
      ref="operateApiDialog"
      :contractorId="detailContractorId"
      :permitsId="permitsId"
      :flowTaskId="flowTaskId"
      :operateApiProps="operateApiProps"
      :apiForm="apiForm"
      :FormData="formData"
      @refreshList="refreshList"
      @cancel="handleCancel"
    ></operate-api-dialog>

    <!-- 流程弹窗 -->
    <ApprovalFlowDialog
      :visible.sync="approvalFlowDialog"
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>
  </el-card>
  <ContractorStartGuidelines
    :contractorId="contractorId"
    :profileTemplateId="profileTemplateId"
    @back="back"
    v-else
  />
</template>

<script>
import { WorkPermitApi, ContractorAccountRelationApi } from '@wiz-api/contractor-management'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import { workFlowStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import PreviewButton from '@/components/previewButton/PreviewButton'
import qs from 'qs'

const workPermitApi = new WorkPermitApi()
const contractorAccountRelationApi = new ContractorAccountRelationApi()

const OperateApiDialog = () => {
  return import('../components/OperateApiDialog')
}
const ContractorStartGuidelines = () => {
  return import('./ContractorStartGuidelines')
}

export default {
  name: 'contractor-start-permission',
  components: {
    OperateApiDialog,
    ContractorStartGuidelines,
    TableOperateButton,
    ApprovalFlowDialog,
    PreviewButton
  },
  data() {
    return {
      tableLoading: false,
      operLoading: false,
      formData: {},
      approvalFlowDialog: false,
      flowTaskId: null,
      rowId: null,
      WorkflowList: [],
      contractorId: '',
      detailContractorId: '',
      profileTemplateId: '',
      isList: true,
      searchData: {
        orgName: '',
        applyTimeStart: '',
        applyTimeEnd: '',
        workflowStatus: '',
      },
      permitsId: '',
      showOperateApiDialog: false,
      operateApiProps: {
        title: '开工许可申请',
        editType: 'create',
        visible: true,
      },
      apiForm: {
        name: '',
        displayName: '',
        userClaims: [
          'email',
          'email_verified',
          'name',
          'phone_number',
          'phone_number_verified',
          'role',
        ],
        description: '',
        enabled: true,
        showInDiscoveryDocument: true,
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      sort: {
        type: '',
        sortName: 'applyTime',
      },
    }
  },
  methods: {
    async handleCancel() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.showOperateApiDialog = false
    },
    async handleEvent(row, type) {
      let err = null
      let res = null
      switch (type) {
        case 'submit':
          this.$confirm('是否确认提交当前记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.operLoading = true
              ;[err, res] = await workPermitApi.submit({ workPermitId: row.id })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '提交成功',
                  type: 'success',
                })
              }
              this.handleSearch()
              this.operLoading = false
            })
            .catch(() => {})
          break
        case 'audit':
          this.editApi('approve', {
            id: row.id,
          })
          ;[err, res] = await workPermitApi.get(row.id)
          if (!err) {
            this.detailContractorId = res.contractorId
            this.formData = { ...res, taskId: row.taskId }
          }
          break
        case 'readFlow':
          this.flowTaskId = row.flowTaskId
          if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
            window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
          } else {
            this.approvalFlowDialog = true
          }
          break
        default:
          break
      }
    },
    openPermission() {
      if (this.contractorId && this.profileTemplateId) {
        this.isList = false
      } else {
        // 非承包商已隐藏按钮，这里是没配置模板的承包商
        this.$confirm('当前承包商没有配置模板，是否创建表单', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await workPermitApi.create({
              body: {
                contractorId: this.contractorId,
                applyTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              },
            })
            if (!err) {
              this.$message.success({
                showClose: true,
                message: '创建成功',
              })
              this.findList()
            }
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    back() {
      this.isList = true
      this.findList()
    },
    sortChangeTable(sortColumn) {
      if (_.isNil(sortColumn.column)) {
        return
      }
      this.sort.type = sortColumn.order === 'ascending' ? 0 : 1
      this.sort.sortName = sortColumn.prop
      this.findList()
    },
    handleSearch() {
      this.page.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    async findList() {
      const searchData = Object.fromEntries(
        Object.entries(this.searchData).filter(([key, value]) => {
          return value !== null && value !== undefined && value
        })
      )
      this.tableLoading = true
      if (window.__POWERED_BY_QIANKUN__) {
        // 低代码
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.get(
          `/api/contractor-management/work-permits/paged-list-query?${qs.stringify({
            skipCount: (this.page.pageNo - 1) * this.page.pageSize,
            maxResultCount: this.page.pageSize,
            sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
            ...searchData,
          })}`
        )
        if (res.status === 200 && res.data) {
          this.tableData = res.data.items
          this.page.pageTotal = res.data.totalCount
        }
        this.tableLoading = false
        return
      }
      const [err, res] = await workPermitApi.pagedListQuery({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
        ...searchData,
      })
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
      this.tableLoading = false
    },
    async editApi(type, row) {
      this.flowTaskId = row.flowTaskId || ''
      this.permitsId = row.id
      this.detailContractorId = row.contractorId
      this.operateApiProps.editType = type
      this.operateApiProps.title = `承包商开工许可${this.toTypeStr(type)}`
      this.showOperateApiDialog = true
    },
    toTypeStr(type) {
      switch (type) {
        case 'edit':
          return '编辑'
        case 'read':
          return '详情'
        default:
          return '审批'
      }
    },
    /**
     * @description: 删除api
     * @param {*}
     * @return {*}
     */
    deleteApi(id) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await workPermitApi.callDelete(id)
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功',
            })
            this.handleSearch()
          }
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    async refreshList() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.showOperateApiDialog = false
      this.findList()
    },
    async getContractorInfo() {
      // 拿承包商id和模板id
      const [err, res] = await contractorAccountRelationApi.getContractorAccountRelationByUserDto()
      if (!err) {
        this.contractorId = res.contractorId
        this.profileTemplateId = res.profileTemplateId
      }
    },
  },
  computed: {
    menuId() {
      return window?.wiz?._route?.meta?.Id ? window.wiz._route.meta.Id : ''
    },
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    workFlowStatusTypes() {
      return (val) => {
        return workFlowStatusTypes(val)
      }
    },
    filtersWorkflowStatus() {
      return (val) => {
        return (
          this.WorkflowList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.editApi('read', val)
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.editApi('edit', val)
            },
            isShow: this.$hasAccess('update') && [0, 3].includes(val.workflowStatus),
          },
          {
            text: '删除',
            click: () => {
              return this.deleteApi(val.id)
            },
            isShow: this.$hasAccess('delete') && [0, 3].includes(val.workflowStatus),
          },
          {
            text: '提交',
            click: () => {
              return this.handleEvent(val, 'submit')
            },
            isShow:
              this.$hasAccess('submit') &&
              [0, 3].includes(val.workflowStatus) &&
              !val.isBlock &&
              val.status !== 2 &&
              !this.operLoading,
          },
          {
            text: '审批',
            click: () => {
              return this.handleEvent(val, 'audit')
            },
            isShow:
              this.$hasAccess('audit') &&
              val.oprateCode === '001' &&
              [1].includes(val.workflowStatus),
          },
          {
            text: '查看流程',
            click: () => {
              return this.handleEvent(val, 'readFlow')
            },
            isShow: this.$hasAccess('readFlow') && val.flowTaskId,
          },
        ]
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  async created() {
    if (this.$route.query.id && this.$route.query.taskId && this.$route.query.mode) {
      this.editApi(this.$route.query.mode === 'approve' ? 'approve' : 'read', {
        id: this.$route.query.id,
        flowTaskId: this.$route.query.taskId,
      })
      const [err, res] = await workPermitApi.get(this.$route.query.id)
      if (!err) {
        this.detailContractorId = res.contractorId
        this.formData = { ...res, taskId: this.$route.query.taskId }
      }
    }
    utils.getDataCategory(
      ['ContractorManagement.DataCategory.WorkflowStatus'],
      ['WorkflowList'],
      this
    )
    this.getContractorInfo()
    this.handleSearch()
    // 待办跳转处理
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
